import { service, localStorageAdapter } from '@/services/app.service';
var endpoints = {
    CLAIM: function (base) { return "/admin/squib_guest_customer?base=" + base; },
    RELEASE: function (base, customerId) { return "/admin/squib_guest_customer?base=" + base + "&cb=" + customerId + "&cmd=RELEASE"; },
};
var guestService = {
    fetchGuestCustomer: function (base, callback) {
        var guest = localStorageAdapter.getItem('guest-customer-id');
        if (guest && guest.customerId) {
            callback({
                customerId: guest.customerId,
                success: true,
            });
            return;
        }
        var claimCustomer = service.get(endpoints.CLAIM(base));
        claimCustomer.then(function (response) {
            var body = response.data.body || null;
            var customerId = body.customer_id || null;
            if (!customerId) {
                callback({
                    customerId: null,
                    success: false,
                });
                return;
            }
            var basePrefix = base.split('~')[0];
            var customerIdPrefix = customerId.split('~')[0];
            if (customerIdPrefix !== basePrefix) {
                callback({
                    customerId: null,
                    success: false,
                });
                return;
            }
            localStorageAdapter.setItem('guest-customer-id', { customerId: customerId });
            callback({
                customerId: customerId,
                success: true,
            });
        }).catch(function (err) {
            callback({
                customerId: null,
                success: false,
            });
        });
    },
    releaseGuestCustomer: function (_a, callback) {
        var base = _a.base, customerId = _a.customerId;
        var useGuestId = customerId;
        var guest = localStorageAdapter.getItem('guest-customer-id');
        if (guest && guest.customerId) {
            useGuestId = guest.customerId;
        }
        if (!useGuestId) {
            return;
        }
        var releaseCustomer = service.get(endpoints.RELEASE(base, useGuestId));
        releaseCustomer.then(function (response) {
            var body = response.data.body;
            var released = body.released;
            var customerId = body.customer_id;
            localStorageAdapter.setItem('guest-customer-id', { customerId: null });
            callback({
                released: released,
                customerId: customerId,
            });
        });
    }
};
export default guestService;



//////////////////
// WEBPACK FOOTER
// ./src/services/guest.service.ts
// module id = z3C7
// module chunks = 18